/**
 * This module imports the appropriate theme CSS file.
 *
 * IMPORTANT: Do not add imports to this file because CSS need to be imported
 * before the modules that use THEME_COLOR are referenced.
 */
import { BRANDING_OPTIONS } from "@brandingConfig";
const THEME_NAME = BRANDING_OPTIONS.themeName || "default";

// Static switch over the literal theme imports (was a dynamic
// import("./index." + THEME_NAME + ".less")). Static specifiers let every bundler
// resolve the chunk without @rollup/plugin-dynamic-import-vars (Vite) and are
// neutral for webpack/Rspack. Still a dynamic import() so the theme stays a
// separate chunk and loads before THEME_COLOR consumers. Add a case per new theme.
export default (() => {
  switch (THEME_NAME) {
    case "group-s":
      return import("./index.group-s.less");
    case "septeo":
      return import("./index.septeo.less");
    default:
      return import("./index.default.less");
  }
})();
